<template>
  <Modal @show="onShow">
    <template #header>Submit feedback</template>

    <template #body>
      <v-form class="d-flex flex-column tw-gap-2" @submit.prevent v-model="isValid">
        <p>
          Report a bug, share a suggestion or anything else you want to let us know? Please submit it here and we will get back to you ASAP!
        </p>

        <FormControl>
          <template #title>Category</template>
          <v-select variant="outlined" :rules="[isRequired]" :items="FEEDBACK_CATEGORIES" v-model="feedback.reason" />
        </FormControl>

        <FormControl>
          <template #title>Message</template>
          <v-textarea auto-grow autofocus clearable rows="4" variant="outlined" :rules="[isRequired]" v-model="feedback.description" />
        </FormControl>
      </v-form>
    </template>

    <template #footer>
      <ModalActionSecondary @click="closeModal">Cancel</ModalActionSecondary>
      <ModalActionPrimary :disabled="!isValid" @click="modalData.onSubmit(feedback)">Submit</ModalActionPrimary>
    </template>
  </Modal>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { useModal } from '@console/composables';
import { FormControl } from '@console/ui/next/Form';
import { isRequired } from '@console/utils';
import { Modal, ModalActionPrimary, ModalActionSecondary } from '../Modal';

const FEEDBACK_CATEGORIES = ['Suggestion', 'Bug', 'Other'];

const { closeModal, modalData } = useModal();
const isValid = ref(false);
const feedback = ref<{ description: string; reason: string }>({ description: '', reason: FEEDBACK_CATEGORIES[0] });
const onShow = () => {
  feedback.value = { description: '', reason: FEEDBACK_CATEGORIES[0] };
};
</script>
